/* MHSys Schnellansicht (Roadmap 3.25) - ein Produkt im Overlay statt auf einer neuen Seite, zuerst im
 * Geschenkefinder: man springt nicht aus der Suche.
 *
 * - Geladen nur auf den Finder-Seiten (layout/theme.liquid). An ist sie mit dem Theme-Schalter
 *   "Schnellansicht im Geschenkefinder" - oder im eigenen Browser zum Testen: ?schnellansicht=test merkt
 *   es sich (localStorage), ?schnellansicht=aus vergisst es. Aus: der Treffer bleibt ein normaler Link.
 * - Inhalt: sections/mhsys-schnellansicht.liquid ueber Section Rendering, erst beim Antippen. Nichts auf
 *   Vorrat - auch Produkt-CSS und -Skripte (mhsys-produkt, mhsys-produktoptionen) kommen erst mit dem
 *   ersten Oeffnen. Ein geladenes Produkt bleibt fuer die Dauer der Seite im Speicher.
 * - Gekauft wird mit dem echten Kaufformular: <mhsys-kaufformular> richtet sich selbst ein, Variantenwahl
 *   und Menge/Mindestmenge ueber window.mhsysProduktKauf(), Produktoptionen ueber window.mhsysPoEinrichten().
 *   _quelle geschenkefinder setzt assets/mhsys-quelle.js wie bei jedem Kauf; den Klick merkt sich der
 *   Finder (assets/mhsys-geschenkefinder.js), bevor dieses Skript den Link abfaengt.
 * - Nach dem Einlegen geht das Overlay zu und die Warenkorb-Schublade auf (Inhaber 21.09.2026).
 * - Zurueck-Taste des Handys schliesst: beim Oeffnen ein eigener Verlaufseintrag. Den Eintrag darunter
 *   markiert es (mhsysSchnellansichtBasis), damit der Finder beim Zurueck nicht auf Frage 4 springt -
 *   dessen popstate-Zweig uebergeht diesen Fall. Nach dem Schliessen kommt die Markierung wieder weg.
 * - Escape, Klick daneben und X schliessen; Fokusfalle; Fokus danach zurueck auf den Treffer.
 * - Ebene 2147483000: unter der Schublade und den Info-Popups (--mhsys-z-overlay), ueber Chat und
 *   "5 % Rabatt". Aus der Warenkorb-Schublade geoeffnet (Roadmap 4.12, window.mhsysSchnellansichtOeffnen,
 *   Skript von assets/mhsys-warenkorb.js beim ersten Klick nachgeladen) liegt sie UEBER der Schublade
 *   (.mhsys-sa--ueber), Info-Popups darin noch darueber (html.mhsys-sa-ueber); Tab und Escape gehoeren
 *   dann ihr, nicht der Schublade darunter.
 */
(() => {
  'use strict';

  const cfg = window.mhsysSchnellansicht || {};

  let an = !!cfg.an;
  try {
    const p = new URLSearchParams(location.search).get('schnellansicht');
    if (p === 'test') localStorage.setItem('mhSchnellansichtTest', '1');
    if (p === 'aus') localStorage.removeItem('mhSchnellansichtTest');
    if (localStorage.getItem('mhSchnellansichtTest') === '1') an = true;
  } catch (e) {}
  if (!an) return;

  const TREFFER_LINK = '.mhsys-finder__treffer .mhsys-kachel a[href*="/products/"]';
  const wurzel = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const zwischenspeicher = new Map();
  let overlay = null;
  let inhalt = null;
  let ausloeser = null;
  let dateienLaden = null;
  let laufNr = 0;
  let ueber = false;

  /* Produkt-CSS und -Skripte einmal nachladen; ein Fehler blockiert nicht (dann ohne Einrichtung) */
  function dateien() {
    if (dateienLaden) return dateienLaden;
    const css = (cfg.css || []).map((href) => new Promise((fertig) => {
      if (document.querySelector(`link[href="${CSS.escape(href)}"]`)) return fertig();
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.onload = l.onerror = () => fertig();
      document.head.appendChild(l);
    }));
    const js = (cfg.js || []).map((src) => new Promise((fertig) => {
      if (document.querySelector(`script[src="${CSS.escape(src)}"]`)) return fertig();
      const s = document.createElement('script');
      s.src = src;
      s.onload = s.onerror = () => fertig();
      document.head.appendChild(s);
    }));
    dateienLaden = Promise.all(css.concat(js));
    return dateienLaden;
  }

  function aufbauen() {
    overlay = document.createElement('div');
    overlay.className = 'mhsys-sa';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="mhsys-sa__schleier" data-mhsys-sa-zu></div>' +
      '<div class="mhsys-sa__panel" role="dialog" aria-modal="true" aria-labelledby="mhsys-sa-titel" tabindex="-1">' +
      '<button type="button" class="mhsys-sa__zu mhsys-ueberlage__zu" data-mhsys-sa-zu aria-label="Schließen">' +
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M5.05 3.9c.3 0 .6.12.83.35L12 10.37l6.12-6.12a1.17 1.17 0 0 1 1.66 1.66L13.66 12l6.12 6.12a1.17 1.17 0 0 1-1.66 1.66L12 13.66l-6.12 6.12a1.17 1.17 0 0 1-1.66-1.66L10.34 12 4.22 5.88A1.17 1.17 0 0 1 5.05 3.9Z"/></svg>' +
      '</button><div class="mhsys-sa__inhalt"></div></div>';
    inhalt = overlay.querySelector('.mhsys-sa__inhalt');
    overlay.addEventListener('click', (e) => {
      if (e.target.closest('[data-mhsys-sa-zu]')) schliessen(true);
    });
    document.body.appendChild(overlay);
  }

  function istOffen() {
    return !!overlay && !overlay.hidden;
  }

  function zeigen() {
    if (!overlay) aufbauen();
    overlay.hidden = false;
    overlay.classList.toggle('mhsys-sa--ueber', ueber);
    document.documentElement.classList.toggle('mhsys-sa-ueber', ueber);
    document.documentElement.classList.add('mhsys-sa-offen');
    overlay.querySelector('.mhsys-sa__panel').focus({ preventScroll: true });
  }

  function verstecken(fokusZurueck) {
    if (!istOffen()) return;
    laufNr++;
    overlay.hidden = true;
    inhalt.replaceChildren();
    document.documentElement.classList.remove('mhsys-sa-offen', 'mhsys-sa-ueber');
    ueber = false;
    if (fokusZurueck && ausloeser && document.contains(ausloeser)) ausloeser.focus({ preventScroll: true });
  }

  function htmlHolen(handle) {
    if (zwischenspeicher.has(handle)) return Promise.resolve(zwischenspeicher.get(handle));
    return fetch(`${wurzel}products/${encodeURIComponent(handle)}?section_id=mhsys-schnellansicht`)
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error('schnellansicht'))))
      .then((html) => {
        zwischenspeicher.set(handle, html);
        return html;
      });
  }

  function oeffnen(handle, url, mitVerlauf) {
    zeigen();
    const nr = ++laufNr;
    inhalt.setAttribute('aria-busy', 'true');
    /* Brezn als Ladeanzeige (Roadmap 4.14, assets/mhsys-popup.js); ohne sie der Text wie bisher */
    if (typeof window.mhsysLadeAnzeige === 'function') inhalt.replaceChildren(window.mhsysLadeAnzeige());
    else inhalt.innerHTML = '<p class="mhsys-sa__laden">Wird geladen …</p>';

    if (mitVerlauf) {
      try {
        const basis = Object.assign({}, history.state || {}, { mhsysSchnellansichtBasis: true });
        history.replaceState(basis, '');
        const eigen = Object.assign({}, history.state || {}, { mhsysSchnellansicht: handle });
        delete eigen.mhsysSchnellansichtBasis;
        history.pushState(eigen, '');
      } catch (e) {}
    }

    Promise.all([htmlHolen(handle), dateien()])
      .then(([html]) => {
        if (nr !== laufNr) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const produkt = doc.querySelector('[data-mhsys-schnellansicht-produkt]');
        if (!produkt) throw new Error('leer');
        const neu = document.importNode(produkt, true);
        /* Aus der Warenkorb-Schublade (Roadmap 4.12, MASTER 22.09.2026): Sterne und "Fragen?" fuehren auf die
           Produktseite und damit aus der Schublade heraus. Die Sterne bleiben als Text stehen (die Zahl hilft
           beim Entscheiden), "Fragen?" faellt weg - eine dritte Overlay-Ebene fuer Bewertungen bzw. das
           Fragen-Formular waere mehr, als dieser Blick braucht. "Alle Details zum Produkt" bleibt der bewusste
           Weg zur Seite. Im Geschenkefinder bleibt es bei den Links (Inhaber 21.09.2026). */
        if (ueber) {
          neu.querySelectorAll('a.mhsys-bewertung-kurz').forEach((a) => {
            const text = document.createElement('span');
            text.className = a.className;
            text.innerHTML = a.innerHTML;
            a.replaceWith(text);
          });
          neu.querySelectorAll('.mhsys-pfr-anzahl-wrap').forEach((n) => n.remove());
        }
        inhalt.replaceChildren(neu);
        inhalt.removeAttribute('aria-busy');
        if (typeof window.mhsysProduktKauf === 'function') window.mhsysProduktKauf(neu);
        if (typeof window.mhsysPoEinrichten === 'function') window.mhsysPoEinrichten();
      })
      .catch(() => {
        /* Laesst sich das Overlay nicht fuellen, dann eben die Produktseite */
        if (nr === laufNr) location.href = url;
      });
  }

  /* Schliessen ueber den eigenen Verlaufseintrag, damit Zurueck und X dasselbe tun */
  function schliessen(fokusZurueck) {
    if (!istOffen()) return;
    const eigen = history.state && history.state.mhsysSchnellansicht;
    if (eigen) {
      overlay.dataset.fokusZurueck = fokusZurueck ? '1' : '';
      history.back();
    } else {
      verstecken(fokusZurueck);
    }
  }

  window.addEventListener('popstate', (e) => {
    const handle = e.state && e.state.mhsysSchnellansicht;
    if (handle) {
      /* Vorwaerts auf einen alten Schnellansicht-Eintrag: wieder oeffnen, ohne neuen Eintrag */
      if (!istOffen()) oeffnen(handle, `${wurzel}products/${handle}`, false);
      return;
    }
    if (e.state && e.state.mhsysSchnellansichtBasis) {
      const ohne = Object.assign({}, e.state);
      delete ohne.mhsysSchnellansichtBasis;
      try { history.replaceState(ohne, ''); } catch (err) {}
    }
    if (istOffen()) {
      const fokus = overlay.dataset.fokusZurueck !== '';
      overlay.dataset.fokusZurueck = '1';
      verstecken(fokus);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const link = e.target.closest(TREFFER_LINK);
    if (!link || link.target === '_blank' || link.origin !== location.origin) return;
    const handle = link.pathname.split('/products/')[1];
    if (!handle) return;
    e.preventDefault();
    ausloeser = link;
    oeffnen(decodeURIComponent(handle.replace(/\/$/, '')), link.href, true);
  });

  /* Aus der Warenkorb-Schublade (Roadmap 4.12): Positionen und Empfehlungen. false = kein Produktlink,
     dann nimmt die Schublade den normalen Link. */
  window.mhsysSchnellansichtOeffnen = (link) => {
    if (!link || link.origin !== location.origin) return false;
    const handle = link.pathname.split('/products/')[1];
    if (!handle) return false;
    /* Schon offen (Doppelklick): nicht ein zweites Mal oeffnen - das legte einen zweiten Verlaufseintrag an, und
       Escape/Zurueck schloss dann nur einen davon. Seit die Schublade das Skript vorlaedt (Roadmap 4.14), faengt
       das Warten aufs Skript den zweiten Klick nicht mehr ab. */
    if (istOffen()) return true;
    ausloeser = link;
    /* Ueber der Schublade, wenn der Link darin steht ODER die Schublade offen ist: beim ersten Klick laedt die
       Schublade dieses Skript erst nach, und baut sie sich in der Zeit neu auf (langsames Netz), haengt der
       Link nicht mehr im Dokument - closest() fand dann nichts, und die Schnellansicht lag HINTER der Schublade
       (gefunden unter "Slow 4G", Roadmap 4.14). */
    ueber = !!link.closest('mhsys-warenkorb') || !!document.querySelector('mhsys-warenkorb.is-offen');
    oeffnen(decodeURIComponent(handle.replace(/\/$/, '')), link.href, true);
    return true;
  };

  /* Eingelegt: Overlay zu, die Schublade ist schon auf - Fokus nicht zuruecknehmen */
  document.addEventListener('mhsys:warenkorb-geaendert', (e) => {
    const q = e.detail && e.detail.quelle;
    if (istOffen() && (q === 'kaufformular' || q === 'produktoptionen')) schliessen(false);
  });

  document.addEventListener('keydown', (e) => {
    if (!istOffen()) return;
    /* Obenauf liegt etwas anderes (Vollbild der Galerie, Info-Popup, Schublade): das schliesst selbst */
    const obenauf = document.querySelector('dialog[open]') ||
      document.querySelector('.mhsys-popup:not([hidden])') ||
      (!ueber && document.querySelector('mhsys-warenkorb.is-offen, .mhsys-wk.is-offen'));
    if (e.key === 'Escape') {
      if (!obenauf) schliessen(true);
      return;
    }
    if (e.key !== 'Tab' || obenauf) return;
    const panel = overlay.querySelector('.mhsys-sa__panel');
    const ziele = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter((el) => el.offsetParent !== null);
    if (!ziele.length) return;
    const erstes = ziele[0];
    const letztes = ziele[ziele.length - 1];
    const drin = panel.contains(document.activeElement) && document.activeElement !== panel;
    if (e.shiftKey && (!drin || document.activeElement === erstes)) {
      e.preventDefault();
      letztes.focus();
    } else if (!e.shiftKey && (!drin || document.activeElement === letztes)) {
      e.preventDefault();
      erstes.focus();
    }
  });
})();
